<template>
    <div class="page">
        <!-- 吸顶导航栏 -->
        <div
            :class="['top-nav', screenHeight >= 812 ? 'maxTopNav' : 'minTopNav']"
            v-show="showTopNav"
        >
            <template v-if="isOldCustomer">
                <div class="nav-leftitem" @click="goback">
                    <div v-if="showNavbarBack" class="nav-back"></div>
                    <span class="nav-value1">活力值</span>
                    <span class="nav-value2">{{ scoreInfo.totalScore }}</span>
                    <span class="nav-value3" v-if="scoreInfo.differenceOfNextLockScore > 0"
                        >(再获{{ scoreInfo.differenceOfNextLockScore }}活力值可升级)</span
                    >
                </div>
                <div class="nav-rightitem" @click="rightNavItemClick">
                    {{ navRightInfo.linkName }}
                </div>
            </template>
            <template v-else>
                <div v-if="showNavbarBack" class="nav-back-div" @click="goback"></div>
                <div :class="['nav-title', showNavbarBack ? 'nav-title1' : 'nav-title2']"></div>
            </template>
        </div>
        <template v-if="!isOldCustomer">
            <newuserCard
                :newCardData="introBenefit"
                :navbarBack="showNavbarBack"
                @OnGoBack="goback"
                @OnBenefitClick="newUserBenefitClick"
                @OnLoanButnClick="loanButnClick"
            ></newuserCard>
        </template>
        <template v-else>
            <homeCard
                :guideNotice="userGuideNotice"
                :navbarBack="showNavbarBack"
                :upFloatWindowData="upFloatWindowInfo"
                :showTaskGuide="showTaskGuide"
                :navRightData="navRightInfo"
                :taskListData="taskScoreValueList"
                :switch3dCat="switch3d"
                ref="homeCard"
                @onShowUpgrade="showUpgradePopup"
                @OnShowFirstUpgardePopup="showFirstUpgradePopup"
                @OnQiPaoSucc="qipaoSuccess"
                @OnshowTaskList="showTaskListClick"
                @OnGoBack="goback"
                @OnScoreRecord="scoreRecordClick"
                @OnShowOverdueDialog="showOverduePopup"
                @OnMarketTipClick="marketTipClick"
                @OnBubbleScoreList="getBubbleScoreList"
            ></homeCard>
            <template v-if="scoreInfo.totalScore > 0">
                <rightsCard
                    v-if="
                        currentScoreSectionBenefitList && currentScoreSectionBenefitList.length > 0
                    "
                    :currScoreData="currentScoreSectionBenefitList"
                    :scoreInfoData="scoreInfo"
                    :switch3DCat="switch3d"
                    @OnCurrBenefitClick="currBenefitClick"
                    @OnAllBenefitClick="allGradesClick"
                ></rightsCard>
            </template>
            <template v-else>
                <lowerRightsCard
                    :lowerBenefitData="lowerBenefitContent"
                    :scoreInfoData="scoreInfo"
                    :switch3DCat="switch3d"
                    @OnAllbenefitClick="allGradesClick"
                    @OnlowerItemClick="lowerItemClick"
                ></lowerRightsCard>
            </template>
        </template>
        <!-- 个人权益模块 -->

        <DailyTask
            v-if="daysTaskArr && daysTaskArr.length > 0"
            :daysTaskData="daysTaskArr"
            :scoreInfoData="scoreInfo"
            :switch3DCat="switch3d"
            @OnShowTaskList="showTaskListClick"
        />
        <!-- 付费权益模块 -->
        <div class="svip-div" v-if="isOldCustomer && payBenefit && payBenefit.svip">
            <div class="vip-title">超级权益专享折扣价</div>
            <div class="vip-desc">
                <span>升至{{ payBenefit.score }}活力值可享</span>
                <span style="color: #ff914e; font-weight: bold">{{ payBenefit.discount }}</span
                >优惠
            </div>
            <div class="vip-card" v-if="payBenefit.svip" @click="svipClick(payBenefit.svip)">
                <div class="card-title">拍金卡</div>
                <div class="card-desc">
                    开通会员预计可省{{ payBenefit.svip.saveAmount / 100 }}元/年
                </div>
                <div class="card-price">
                    原价 ￥{{ payBenefit.svip.price / 100 }}
                    <div class="card-butn">立即开通</div>
                </div>
            </div>
            <div class="quan-card" v-if="false">
                <template v-if="payBenefit.couponPackage.length === 2">
                    <div
                        class="quan-item"
                        v-for="(item, index) in payBenefit.couponPackage"
                        :key="index"
                        @click="couponPackageClick(item)"
                    >
                        <div class="quan-title">{{ item.title }}</div>
                        <div class="quan-desc">
                            {{ item.couponAmount / 100 }}元免息券 x {{ item.couponNum }}张
                        </div>
                        <div class="quan-bottom">
                            <div class="quan-price">购买价 ￥{{ item.price / 100 }}</div>
                            <div class="quan-butn">购买</div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="quan-bg" @click="couponPackageClick(payBenefit.couponPackage[0])">
                        <div class="quan-left">
                            <div class="quan-left-tit">尊享免息券包</div>
                            <div class="quan-left-des">
                                {{ payBenefit.couponPackage[0].couponAmount / 100 }}元免息券 x
                                {{ payBenefit.couponPackage[0].couponNum }}张
                                <span class="quan-buy-des"
                                    >购买价 ￥{{ payBenefit.couponPackage[0].price / 100 }}</span
                                >
                            </div>
                        </div>
                        <div class="quan-right">购买</div>
                    </div>
                </template>
            </div>
        </div>
        <giftList
            ref="giftListCard"
            :loanLink="loanUrl"
            @OnShowTaskList="showTaskListClick"
            @OnLoanButnClick="loanButnClick"
        />
        <!-- 任务弹窗 -->
        <taskListPopup
            ref="taskListPopupRef"
            :visible.sync="showTaskListPopup"
            :taskListInfo="taskListContent"
            :scoreInfoData="scoreInfo"
            @OnOpenLinkClick="opneTastListLinkClick"
            @OnCloseTaskListPop="closeTaskListPopUp"
            @OnClickNoticeType="noticeTypeClick"
            @OnMarketTipClick="marketTipClick"
            @OnSigntakeSuccCallBack="getUserNotice"
            @refreshTaskList="getTaskScoreValueList"
            @OnReceiveScoreTask="receiveScoreTaskHanlder"
        ></taskListPopup>
        <!-- 升级弹窗 -->
        <upgradePopup
            v-if="showUpgratePopup"
            :updateInfo="updateInfo"
            :score="updateTotalScore"
            :switch3DCat="switch3d"
            @onOpen="closeUpdatePopup"
        ></upgradePopup>
        <firstUpgradePop
            v-show="showFirstUpgradePop"
            :showFirstUpgrade="showFirstUpgradePop"
            :scoreInfoData="scoreInfo"
            :switch3DCat="switch3d"
            @OnConfirmClick="firstUpgradeConfirmClick"
        />
        <verUpgradePop
            v-if="showGradeV4Pop"
            :scoreInfoData="scoreInfo"
            @OnPopupClose="popUpClose"
        />
        <systemPop v-if="showSystemPopup" />
        <noticePop v-if="showNoticePopup" @OnClosePage="goback" />
        <Dialog
            :show="showOverdueDialog"
            title="对不起，您当前存在逾期，请先完成还款。"
            lefttxt="再看看"
            righttxt="去还款"
            @giveupBtn="giveupToRepay"
            @continueBtn="doSomeRepay"
        />
        <!-- 浮层引导 -->
        <taskGuide
            v-if="showTaskGuide"
            :guideType="taskGuideType"
            :bubbleData="bubbleInfo"
            :scoreInfoData="scoreInfo"
            :taskListData="taskScoreValueList"
            @OnGuideClick="taskGuideClick"
        />
        <!-- 新手引导 -->
        <newsGuide
            v-show="showNewUserGuide"
            :newUserGuideType="newUserGuideNum"
            :newUserGuidArr="newUserGuidData"
            :scoreInfoData="scoreInfo"
            :taskListData="taskScoreValueList"
            :switch3DCat="switch3d"
            @OnSkipNoviceGuide="skipNoviceGuide"
            @OnQPGuideClick="qpGuideClick"
            @OnMarkGuideRead="markNewGuideRead"
        ></newsGuide>
        <!-- 首页卡片气泡引导 -->
        <homecardGuide
            v-if="showHomecardGuide"
            :bubbleScoreData="bubbleScoreList"
            @homecardGuideClose="homecardGuideClose"
        />
        <!--     //榜单弹窗-->
        <GuideModel @closeMask="closeMask" v-if="rankingVisible" @iconClick="iconClick" />
        <div
            v-if="
                floatWindowInfo &&
                floatWindowInfo.imageUrl &&
                floatWindowInfo.floatingWindowType !== 'LOTTIE'
            "
            class="ad-popup"
            :style="{ backgroundImage: `url(${floatWindowInfo.imageUrl})` }"
            @click="floatWindowClick"
        ></div>
        <div
            class="ad-popup-lottie"
            v-else-if="floatWindowInfo && floatWindowInfo.floatingWindowType === 'LOTTIE'"
        >
            <LottieResourceBit
                :lottieJson="floatWindowInfo && floatWindowInfo.lottieJson"
                @click="floatWindowClick"
            />
        </div>
        <!-- 底部通知栏 -->
        <div
            :class="[
                'bottom-notice',
                screenHeight >= 812 && sourcePath ? 'max-screen' : 'min-screen',
            ]"
            v-if="accountSafeTip"
        >
            <div class="notice-content">
                <div class="notice-close" @click="accountTipClick(0)">
                    <div class="notice-x"></div>
                </div>
                <div class="notice-tit" @click="accountTipClick(1)">
                    {{ accountSafeTip.noticeText }}
                </div>
            </div>
            <div class="notice-gif" @click="accountTipClick(1)"></div>
        </div>
    </div>
</template>

<script>
// 顶部气泡模块
import homeCard from '../componets/homeCard/homeCard';
// 未激活用户首页卡片
import newuserCard from '../componets/homeCard/newuser';
// 已获权益卡片
import rightsCard from '../componets/rightsCard/index';
//  初始等级权益卡片
import lowerRightsCard from '../componets/rightsCard/lowerRights';
// 每日任务面板
import DailyTask from '../componets/dailyTask/index';
// 瀑布流组件
// import lifeBenenfit from '../componets/life_benenfit/index';
import giftList from '../componets/gift_list/index.vue';
// 升级弹窗
import upgradePopup from '../componets/upgradePopup/index';
import verUpgradePop from '../componets/upgradePopup/verUpgradePop.vue';
import systemPop from '../componets/upgradePopup/systemPopup.vue';
import noticePop from '../componets/upgradePopup/noticePopup.vue';
// 活力值过期弹窗
import firstUpgradePop from '../componets/upgradePopup/firstUpgradePop';
// 任务弹窗
import taskListPopup from '../componets/taskListPopup/TaskListPopup';
// 浮层引导
import taskGuide from '../componets/guide/taskGuide';
import homecardGuide from '../componets/guide/homecardQPGuide.vue';
// 新手引导
import newsGuide from '../componets/guide/newUserGuide';
import homemixin from '@common/js/mixin';
import mixin4C from '@common/js/mixin4Comp';
import { on, off } from '@/common/util/dom';
import { mapMutations } from 'vuex';
import appBridge from '@/common/util/appBridge';
import callPopup from '@/common/util/callPopup';
import { CountDown } from 'vant';
import GuideModel from '../componets/GuideModel';
import { formatDate, getUrlParms } from '@/common/util/utils';
import LottieResourceBit from '../componets/LottieResourceBit';
export default {
    name: 'INVHome',
    components: {
        homeCard,
        newuserCard,
        rightsCard,
        lowerRightsCard,
        DailyTask,
        upgradePopup,
        giftList,
        firstUpgradePop,
        verUpgradePop,
        systemPop,
        noticePop,
        taskListPopup,
        taskGuide,
        homecardGuide,
        newsGuide,
        CountDown,
        GuideModel,
        Dialog: () => import('../componets/birthday/homeDialog'),
        LottieResourceBit
    },
    mixins: [homemixin, mixin4C],
    data() {
        return {
            showTopNav: false,
            showNavbarBack: true,
            isOldCustomer: localStorage.getItem('KUserisOldCustomer'),
            scoreInfo: {}, // 活力值详情
            showUpgratePopup: false, // 升级弹窗
            showTaskListPopup: false, // 升级任务
            showFirstUpgradePop: false, // 首次升级弹窗
            showOverdueDialog: false,
            showHomecardGuide: false,
            taskListContent: {},
            introBenefit: [], // 新客权益
            loanUrl: '', // 新客发标地址
            payBenefit: {}, // 购买权益模块
            updateInfo: {}, // 升级信息
            updateTotalScore: 0,
            currentScoreSectionBenefitList: [], // 已获取等级权益
            lowerBenefitContent: {}, // 初始等级享有权益
            userGuideNotice: [], // 新手引导提示
            goSetting: false,
            floatWindowInfo: {}, // 右下角悬浮窗信息
            upFloatWindowInfo: {}, // 右上角悬浮窗信息
            showTaskGuide: false, // 任务引导蒙层
            taskGuideType: -1, // 引导蒙层位置
            bubbleScoreList: [], // 页面展示气泡数据
            bubbleInfo: {},
            navRightInfo: {}, // 导航栏右边信息
            firstScoreSection: 0,
            pageStayTimer: '',
            pageStayDuration: 0, // 页面停留时间S
            accountSafeTip: null,
            showNewUserGuide: false, // 新手引导
            showGradeV4Pop: false, // v4版本升级弹窗
            showSystemPopup: false, // 系统升级弹窗
            showNoticePopup: false, // 灰度外用户弹窗
            newUserGuidData: [],
            newUserGuideNum: 0,
            taskScoreValueList: [], // 任务活力值列表
            noticeTypeArr: [],
            daysTaskArr: [], // 每日任务
            titleBar: {
                fullScreen: 1,
                visible: 2,
                leftView: [
                    {
                        action: 'back',
                        color: '#000000',
                        icon: 'ppdwebui://resource/drawable/nav_back',
                        callback: this.goClose
                    }
                ],
                titleView: {
                    text: '成长计划',
                    color: '#000000'
                },
                rightView: []
            },
            isApp: false,
            sourcePath: this.$route.query.source,
            screenHeight: screen.height,
            switch3d: false,
            _mounted: false,
            sceneList: [],
            taskbar_display: false,
            rankingVisible: false,
            redirectUrl: null,
            rewardReceiveStartTime: '',
            activityId: '',
            fromSource: this.$route.query.fromSource || getUrlParms('fromSource')
        };
    },
    beforeDestroy() {
        console.log('homepageClose-00', this.pageStayDuration);
        this.pageCloseImp();
        off(window, 'scroll', this.onWindowScroll);
    },
    mounted() {
        on(window, 'scroll', this.onWindowScroll);
        if (window.PPDWebUI.os.inApp) {
            window.PPDWebUI.CommonService.setNavigation(this.titleBar);
            window.PPDWebUI.ListenerService.pauseListener(async () => {
                console.log('homepageClose-11', this.pageStayDuration);
                this.pageCloseImp();
            });
            window.PPDWebUI.ListenerService.resumeListener(async () => {
                console.log(`resume isAndroid:${this.judgeDeviceType().isAndroid}`);
                // 版本不小于9.4
                // 版本不小于9.4  source 区分二级页面，有source直接曝光,不 需考虑预加载多曝光情况
                let source = this.$route.query.source;
                if (source) {
                    // 二级页面,直接曝光，第一次打开二级页面，Android resumeListener事件无法收到回调，iOS小概率拿不到回调
                    console.log('resumeListener-33');
                    this.getHomePageInfo(source, true, false);
                } else {
                    //  Tab页，需处理预加载
                    if (this.compareAppVer() >= 0) {
                        console.log('resumeListener-11');
                        this.getHomePageInfo(source, true, false);
                    } else {
                        let source = this.judgeDeviceType().isAndroid
                            ? this.$route.query.source
                            : null;
                        console.log('resumeListener-22');
                        this.getHomePageInfo(source, true, false);
                    }
                }
                // 领取成功返回之后调用礼包模块接口
                this.$refs.giftListCard.getGiftPackInfo();
                this.$refs.giftListCard.setMaintenceInfo();
                if (this.goSetting) {
                    this.readRegisterHanlder();
                }
                let updataStr = localStorage.getItem('updata');
                if (updataStr && updataStr === 'true') {
                    this.showTaskListClick();
                    localStorage.setItem('updata', 'false');
                }
            });
        }
        this._mounted = true;
        this.mountedResolve && this.mountedResolve(true);
        if (this.fromSource === 'inv') {
            this.taskList();
        }
    },
    created() {
        let source = this.$route.query.source;
        if (window.PPDWebUI.os.inApp) {
            console.log('H5VisibleService-11', this.compareAppVer());
            if (this.compareAppVer() >= 0) {
                // H5VisibleService 仅支在App版本不小于9.4上支持,
                if (source) {
                    this.getHomePageInfo(source, true, false);
                } else {
                    window.PPDWebUI.H5VisibleService.isVisible(visible => {
                        let param = visible;
                        console.log('H5VisibleService-22', param);
                        this.getHomePageInfo(source, param.visible, false);
                    });
                }
            } else {
                console.log('H5VisibleService-33');
                if (this.judgeDeviceType().isAndroid) {
                    this.getHomePageInfo(source, true, false);
                } else {
                    this.getHomePageInfo(source, source ? true : false, false);
                }
            }
            this.isApp = true;
        } else {
            console.log('H5VisibleService-44');
            this.getHomePageInfo(source, true, false);
        }
        // 绑定全局刷新方法
        // 下拉刷新
        localStorage.setItem('KGrowthSource', source);
        let updataStr = localStorage.getItem('updata');
        if (updataStr && updataStr === 'true') {
            this.showTaskListClick();
            localStorage.setItem('updata', 'false');
        }
        window.reloadH5Page = () => {
            // 版本不小于9.4  source 区分二级页面，有source直接曝光,不 需考虑预加载多曝光情况
            let source = this.$route.query.source;
            if (source) {
                // 二级页面,直接曝光
                console.log('reloadH5Page-33');
                this.getHomePageInfo(this.$route.query.source, true, true);
            } else {
                //  Tab页，需处理预加载
                if (this.compareAppVer() >= 0) {
                    console.log('reloadH5Page-11');
                    this.getHomePageInfo(source, true, true);
                } else {
                    let source = this.judgeDeviceType().isAndroid ? this.$route.query.source : null;
                    console.log('reloadH5Page-22');
                    this.getHomePageInfo(source, true, true);
                }
            }
            // this.$refs.lifeBenefit.pull2Refresh();
            if (!source) {
                if (this.goSetting) {
                    this.readRegisterHanlder();
                }
            }
            let updataStr = localStorage.getItem('updata');
            if (updataStr && updataStr === 'true') {
                this.showTaskListClick();
                localStorage.setItem('updata', 'false');
            }
        };
        this.showNavbarBack = source ? true : false;
        this.openScoreRecord = this.debounce2(
            () => {
                this.openLink(`${window.location.protocol}//invgrowth.ppdai.com/#/records/energy`);
            },
            200,
            true
        );
        this.openCurrBenefit = this.debounce2(
            value => {
                this.openLink(`${window.location.protocol}//invgrowth.ppdai.com/#${value}`);
            },
            200,
            true
        );
        this.openNextBenefitquan = this.debounce2(
            value => {
                this.openLink(`${window.location.protocol}//invgrowth.ppdai.com/#${value}&ksdf=1`);
            },
            200,
            true
        );
        this.openNextBenefit = this.debounce2(
            value => {
                this.openLink(`${window.location.protocol}//invgrowth.ppdai.com/#${value}`);
            },
            200,
            true
        );
        // 添加对话框监听
        // this.addDialogBoxEventListener();
    },
    methods: {
        ...mapMutations('home', ['setOldCustomerField', 'setCurrentScoreData']),
        onWindowScroll() {
            let svipContainerElement = document.querySelector('.page');
            // let top = document.scrollingElement.scrollTop;
            let top = window.pageYOffset;
            if (svipContainerElement) {
                if (top > 84) {
                    if (!this.showTopNav) {
                        svipContainerElement.style.paddingBottom = 20 + 'vw';
                        if (this.getStatusBar() >= '40') {
                            svipContainerElement.style.paddingBottom = 27 + 'vw';
                        }
                    }
                    this.showTopNav = true;
                } else {
                    if (this.showTopNav) {
                        svipContainerElement.style.paddingBottom = 0 + 'vw';
                    }
                    this.showTopNav = false;
                }
            }
        },
        /*
        获取状态栏高度，判断是否有刘海屏幕手机 ,高度大于40则属于有刘海屏幕的
        1.优先从PPDWebUI.JS获取状态栏高度
        2.PPDWebUI.JS获取不到时从UA中获取
                this.showTopNav = true
    */
        getStatusBar() {
            if (window.PPDWebUI && window.PPDWebUI.appInfos) {
                return window.PPDWebUI.appInfos.PPDStatusBar;
            } else {
                let ua = navigator.userAgent;
                if (ua.indexOf('PPDStatusBar') > -1) {
                    let statusBars = ua.match(/;\s+PPDStatusBar\s+(\d+)\)/);
                    if (statusBars.length > 0) {
                        return statusBars[1];
                    }
                }
            }
        },

        getMounted() {
            return new Promise((resolve, reject) => {
                if (this._mounted) {
                    resolve(true);
                }
                this.mountedResolve = resolve;
            });
        },
        setPullToRefresh(gray3d) {
            setTimeout(async () => {
                await this.getMounted();
                const refreshBackColor = gray3d ? '#E6E4DF' : '#3979B9';
                appBridge.pullToRefresh({ refreshBackColor });
            }, 5000);
        },
        goback() {
            if (this.showNavbarBack) {
                window.PPDWebUI.CommonService.close({});
            }
        },
        // 气泡卡片弹窗关闭 v4.0
        homecardGuideClose() {
            this.showHomecardGuide = false;
        },
        // 查询营销任务栏任务信息状态接口
        async getBubbleBarTaskInfo() {
            if (localStorage.getItem('KHomecardGuideShowTrue') === 'true') {
                return;
            }
            // 是否有可领气泡
            let tempArr = [];
            this.bubbleScoreList.forEach(items => {
                if (items.bubbleType === 0) {
                    tempArr.push(items);
                }
            });
            if (tempArr && tempArr.length > 0) {
                let listArr = JSON.parse(localStorage.getItem('KTaskIDListStr'));
                if (listArr && listArr.length > 0) {
                    const { Result, Content } = await this.$http.getBubbleBarTaskInfo({
                        req: listArr
                    });
                    if (Result === 200 && Content) {
                        if (Content.length > 0) {
                            if (!this.showGradeV4Pop) {
                                localStorage.setItem('KHomecardGuideShowTrue', 'true');
                                this.showHomecardGuide = true;
                            }
                        }
                    }
                }
            }
        },
        // 榜单引导弹窗
        async rankingModel() {
            // 活动榜单id
            const res = await this.$http.getCurrentRankingActivityId({});

            const { activityId } = res.Content;
            this.activityId = activityId;

            const { Result, Content } = await this.$http.getrankingpopup({
                rankingActivityId: activityId
            });
            if (Result === 200 && Content) {
                this.rankingVisible = Content.popup;
                this.redirectUrl = Content.redirectUrl;

                if (this.rankingVisible) {
                    const { rewardReceiveStartTime, rewardReceiveEndTime } = (
                        await this.$http.getrankingactivityinfo({ rankingActivityId: activityId })
                    ).Content;
                    this.rewardReceiveStartTime =
                        formatDate(rewardReceiveStartTime) +
                        ' - ' +
                        formatDate(rewardReceiveEndTime);
                    this.POINT('h5_element_imp', {
                        page: 'super-成长权益页',
                        tgt_event_id: 'super_privilege_hlzbdranking_masklayer',
                        tgt_name: 'super-成长权益-活力值榜单活动-蒙层',
                        param: this.isOldCustomer ? this.scoreInfo.totalScore : -1,
                        param1: this.isOldCustomer ? this.scoreInfo.allScore : -1,
                        param2: this.rewardReceiveStartTime,
                        param3: activityId
                    });
                }
            }
        },
        async saverankingpopuprecord() {
            const { Result, Content } = await this.$http.saverankingpopuprecord({
                rankingActivityId: this.activityId
            });
            if (Result === 200) {
            }
        },
        iconClick() {
            this.rankingVisible = false;
            this.saverankingpopuprecord();
            this.openLink(this.redirectUrl);
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_event_id: 'super_privilege_hlzbdranking_masklayer',
                tgt_name: 'super-成长权益-活力值榜单活动-蒙层',
                param: this.isOldCustomer ? this.scoreInfo.totalScore : -1,
                param1: this.isOldCustomer ? this.scoreInfo.allScore : -1,
                param2: this.rewardReceiveStartTime,
                param3: this.activityId,
                param4: '蒙层处右上角资源位',
                url: this.redirectUrl
            });
        },
        closeMask() {
            this.rankingVisible = false;
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_event_id: 'super_privilege_hlzbdranking_masklayer',
                tgt_name: 'super-成长权益-活力值榜单活动-蒙层',
                param: this.isOldCustomer ? this.scoreInfo.totalScore : -1,
                param1: this.isOldCustomer ? this.scoreInfo.allScore : -1,
                param2: this.rewardReceiveStartTime,
                param3: this.activityId,
                param4: '关闭按钮--点击蒙层即关闭',
                url: this.redirectUrl
            });
            this.saverankingpopuprecord();
        },
        accountTipClick(value) {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_event_id: 'h5_ACT_privilege_tzl',
                tgt_name: 'h5-ACT-成长权益-通知栏',
                param: this.isOldCustomer ? this.scoreInfo.totalScore : -1,
                param1: this.isOldCustomer ? this.scoreInfo.allScore : -1,
                param2: this.accountSafeTip.noticeText,
                param3: this.accountSafeTip.redirectUrl,
                param4: value === 0 ? '关闭按钮' : '内容',
                param5: this.switch3d ? '是' : '否'
            });
            if (this.accountSafeTip) {
                this.viewBenefitGuideClose(this.accountSafeTip.noticeType);
            }
            if (value === 0) {
                // 关闭
                this.accountSafeTip = null;
                return;
            }
            if (this.accountSafeTip.redirectUrl) {
                this.openLink(this.accountSafeTip.redirectUrl);
            }
        },
        pageCloseImp() {
            // 页面消失时，底部通知栏设置成已读，
            if (this.accountSafeTip) {
                this.viewBenefitGuideClose(this.accountSafeTip.noticeType);
            }
            if (this.pageStayDuration > 0) {
                console.log('homepageClose-22', this.pageStayDuration);
                this.POINT('h5_element_imp', {
                    page: 'super-成长权益页',
                    tgt_event_id: 'h5_ACT_privilege_close',
                    tgt_name: 'h5-ACT-成长权益-页面关闭',
                    param: this.$route.query.source || '',
                    param1: this.isOldCustomer ? this.scoreInfo.totalScore : -1,
                    param2: this.isOldCustomer ? this.scoreInfo.allScore : -1,
                    param3: this.pageStayDuration,
                    param4: this.switch3d ? '是' : '否'
                });
                this.pageStayDuration = 0;
                clearInterval(this.pageStayTimer);
            }
        },
        async getHomePageInfo(source, isImp, isReloadPageH5) {
            let appV = window.PPDWebUI.os.inApp ? window.PPDWebUI.os.buildVersion : null;
            let requestSource = `resume_${
                this.judgeDeviceType().isAndroid ? 'android' : 'ios'
            }_${source}_${appV}`;
            if (isImp) {
                this.pageStayTimer = setInterval(() => {
                    this.pageStayDuration++;
                }, 1000);
            }
            if (isReloadPageH5) {
                this.$refs.giftListCard.getGiftPackInfo();
                this.$refs.giftListCard.setMaintenceInfo();
            }
            const { Result, Content, ResultMessage } = await this.$http.getHomePageInfoV2({
                requestSource
            });
            if (Result === 200 && Content) {
                this.isOldCustomer = Content.isOldCustomer;
                localStorage.setItem('KUserisOldCustomer', this.isOldCustomer);
                this.setPullToRefresh(this.switch3d);
                this.setOldCustomerField(this.isOldCustomer);
                this.showSystemPopup = Content.isUpgrade;
                if (Content.isOldCustomer) {
                    // 已激活用户
                    this.scoreInfo = Content.scoreInfo;
                    localStorage.setItem('KUserTotalScore', this.scoreInfo.totalScore);
                    localStorage.setItem('KuserAllScore', this.scoreInfo.allScore);
                    this.setCurrentScoreData(this.scoreInfo);
                    if (isImp) {
                        // this.getMarketingBar();
                        // this.firstScoreSection = Content.firstScoreSection;
                        if (this.scoreInfo.totalScore > 0) {
                            this.getgradebenefitinfo(true);
                        } else {
                            this.getnogradebenefitinfo();
                        }
                        this.getUserNotice();
                        this.floatingWindowInfoV2();
                        this.getTaskBarSeivice();
                        this.getTaskScoreValueList();
                        if (!isReloadPageH5) {
                            callPopup.setUp(1, 'InvestGrowthTab');
                        }
                    }
                    this.navRightInfo = Content.cornerLink;
                } else {
                    this.introBenefit = Content.introBenefit || [];
                    this.loanUrl = Content.redirectUrl;
                }
                this.tracker4Home(Content, isImp);
            } else {
                if (Result === 40703) {
                    // 灰度外用户
                    this.showNoticePopup = true;
                }
                this.POINT('h5_auth', {
                    auth_tgt: 'super_privilege_errorMsg',
                    auth_tgt_name: 'super-成长权益-报错集合',
                    page: 'super-成长权益页',
                    ret_code: Result,
                    param: ResultMessage,
                    param1: '/growth/home/getHomePageInfoV2',
                    param2: this.$route.query.source,
                    param3: this.switch3d ? '是' : '否'
                });
            }
        },
        tracker4Home(Content, isImp) {
            this.payBenefit = Content.payBenefit;
            if (!isImp) {
                return;
            }
            this.POINT('h5_element_imp', {
                page: 'super-成长权益页',
                tgt_event_id: 'h5_ACT_privilege',
                tgt_name: 'h5-ACT-成长权益',
                param: this.isOldCustomer ? this.scoreInfo.totalScore : -1,
                param1: this.$route.query.source || '',
                param2: this.isOldCustomer ? this.scoreInfo.allScore : -1,
                param3: this.switch3d ? '是' : '否'
            });
            if (this.payBenefit && this.payBenefit.svip) {
                let item = this.payBenefit.svip;
                this.POINT('h5_element_imp', {
                    page: 'super-成长权益页',
                    tgt_name: 'h5-ACT-成长权益-付费权益',
                    tgt_event_id: 'h5_ACT_privilege_pay',
                    param: this.isOldCustomer ? this.scoreInfo.totalScore : -1,
                    param1: 0,
                    param2: item.status,
                    param7: this.switch3d ? '是' : '否'
                });
            }
            if (this.payBenefit && this.payBenefit.couponPackage) {
                let packageArr = this.payBenefit.couponPackage;
                packageArr.forEach(item => {
                    this.POINT('h5_element_imp', {
                        page: 'super-成长权益页',
                        tgt_name: 'h5-ACT-成长权益-付费权益',
                        tgt_event_id: 'h5_ACT_privilege_pay',
                        param: this.isOldCustomer ? this.scoreInfo.totalScore : -1,
                        param1: item.couponPackType,
                        param3: item.activityType,
                        param4: item.groupId,
                        param5: item.userType,
                        param6: item.couponPackId,
                        param7: this.switch3d ? '是' : '否'
                    });
                });
            }
        },
        // 任务活力值列表获取
        async getTaskScoreValueList() {
            const { Result, Content } = await this.$http.getBubbleTaskList();
            if (Result === 200) {
                this.taskScoreValueList = Content.taskList || [];
            }
        },
        // 已激活用户获取等级权益
        async getgradebenefitinfo(isShowGuide) {
            const { Result, Content, ResultMessage } = await this.$http.getgradebenefitinfo();
            if (Result === 200) {
                if (Content.floatBenefitList) {
                    this.currentScoreSectionBenefitList = Content.floatBenefitList.concat(
                        Content.currentScoreSectionBenefitList
                    );
                    if (isShowGuide) {
                        // 是否有浮动权益蒙层
                        let source = this.$route.query.source;
                        if (source === 'fbyqlb' || source === 'hqqryqlb') {
                            Content.floatBenefitList.forEach((item, index) => {
                                if (this.$route.query.awardKey === item.awardKey) {
                                    document.scrollingElement.scrollTop = 0;
                                    this.taskGuideType = 20 + index;
                                    this.bubbleInfo = item;
                                    this.showTaskGuide = true;
                                }
                            });
                        }
                    }
                } else {
                    this.currentScoreSectionBenefitList = Content.currentScoreSectionBenefitList;
                }
                if (Content.noviceBenefitList) {
                    this.currentScoreSectionBenefitList = Content.noviceBenefitList.concat(
                        this.currentScoreSectionBenefitList
                    );
                }
                if (
                    this.newUserGuideNum === 2 &&
                    this.currentScoreSectionBenefitList &&
                    !this.showFirstUpgradePop &&
                    !this.showUpgratePopup
                ) {
                    if (this.noticeTypeArr.indexOf('noviceGuideBenefitCard') > -1) {
                        this.newUserGuidData = this.currentScoreSectionBenefitList;
                        this.showNewUserGuide = true;
                    }
                }
            } else {
                this.POINT('h5_auth', {
                    auth_tgt: 'super_privilege_errorMsg',
                    auth_tgt_name: 'super-成长权益-报错集合',
                    page: 'super-成长权益页',
                    ret_code: Result,
                    param: ResultMessage,
                    param1: '/growth/home/getgradebenefitinfo',
                    param2: this.$route.query.source,
                    param3: this.switch3d ? '是' : '否'
                });
            }
        },
        // 初始等级用户权益获取
        async getnogradebenefitinfo() {
            const { Result, Content } = await this.$http.getnogradebenefitinfo();
            if (Result === 200) {
                this.lowerBenefitContent = Content;
            }
        },
        // 每日任务模块
        async getTaskBarSeivice() {
            const { Result, Content } = await this.$http.gettaskbar({});
            if (Result === 200) {
                this.daysTaskArr = Content.taskList;
            }
        },
        rightNavItemClick() {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_name: 'h5-ACT-成长权益-首页右上角配置位',
                tgt_event_id: 'h5_ACT_bbsjtc_rule',
                param: this.navRightInfo ? this.navRightInfo.linkName : '',
                param1: this.navRightInfo ? this.navRightInfo.redirectUrl : ''
            });
            if (this.navRightInfo && this.navRightInfo.redirectUrl) {
                this.openLink(this.navRightInfo.redirectUrl);
            }
        },
        scoreRecordClick(value) {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_name: 'h5-ACT-成长权益-活力值',
                tgt_event_id: 'h5_ACT_bbsjtc_hlscore',
                param: this.isOldCustomer ? this.scoreInfo.totalScore : -1,
                param1: this.isOldCustomer ? this.scoreInfo.allScore : -1
            });
            if (value && value.expiringScore > 0) {
                this.viewBenefitGuideClose('scoreExpireTipsM');
            }
            this.openScoreRecord();
        },
        popUpClose() {
            this.showGradeV4Pop = false;
        },
        // 首次升级弹窗
        showFirstUpgradePopup() {
            this.showFirstUpgradePop = true;
            // this.getgradebenefitinfo(false); // 更新等级权益
            // this.$refs.lifeBenefit.pull2Refresh();
        },
        firstUpgradeConfirmClick() {
            console.log('first-11');
            this.showFirstUpgradePop = false;
            this.getgradebenefitinfo(false); // 更新等级权益
            this.getUserNotice();
            this.getTaskScoreValueList();
        },
        showUpgradePopup(value, score) {
            this.getgradebenefitinfo(false); // 更新等级权益
            // this.$refs.lifeBenefit.pull2Refresh();
            this.showUpgratePopup = true;
            this.updateInfo = value;
            this.updateTotalScore = score;
        },
        closeUpdatePopup() {
            this.showUpgratePopup = false;
            this.getUserNotice();
            this.getTaskScoreValueList();
        },
        showTaskListClick(value, callMethod) {
            this.taskList(callMethod);
        },
        opneTastListLinkClick(value) {
            this.openLink(value);
        },
        closeTaskListPopUp() {
            if (window.PPDWebUI.os.inApp) {
                appBridge.pullToRefresh();
            }
            this.showTaskListPopup = false;
            if (window.PPDWebUI.os.inApp) {
                // 兼容vivo Android6.0系统弹窗关闭问题
                let ua = window.navigator.userAgent.toLocaleLowerCase();
                if (ua.indexOf('vivo') > -1 && ua.indexOf('android 6.0') > -1) {
                    console.log('closeTaskListPopUp11', ua);
                    window.location.reload();
                }
            }
        },
        qipaoSuccess(value, value1, qpItem) {
            this.scoreInfo.totalScore = value;
            this.scoreInfo.differenceOfNextLockScore = value1;
            this.$refs.giftListCard.getGiftPackInfo();
            this.getTaskBarSeivice();
            if (qpItem.taskId === 104) {
                this.getgradebenefitinfo(false); // 更新等级权益
                this.getUserNotice();
                this.getTaskScoreValueList();
            }
        },
        newUserBenefitClick(item) {
            if (item.key === 'hxyk') {
                setTimeout(() => {
                    this.openLink(item.redirectUrl);
                }, 200);
            } else if (item.key === 'shiwulibao') {
                this.openLink(
                    `${window.location.protocol}//growthhome.ppdai.com${item.redirectUrl}`
                );
            } else {
                if (
                    item.redirectUrl &&
                    (item.redirectUrl.indexOf('http') > -1 ||
                        item.redirectUrl.indexOf('ppdloanapp') > -1)
                ) {
                    this.openLink(item.redirectUrl);
                } else if (item.redirectUrl) {
                    this.openCurrBenefit(item.redirectUrl);
                }
            }
        },
        currBenefitClick(item) {
            if (item.benefitKey === 'hxyk') {
                setTimeout(() => {
                    this.openLink(item.redirectUrl);
                }, 200);
            } else if (item.benefitKey === 'swlb') {
                this.openLink(
                    `${window.location.protocol}//growthhome.ppdai.com${item.redirectUrl}`
                );
            } else if (['xsqy', 'fdqy'].indexOf(item.benefitKey) > -1) {
                if (item.benefitStatus === 10) {
                    if (item.benefitKey === 'fdqy') {
                        this.receiveFloatBenefit(item);
                    } else if (item.benefitKey === 'xsqy') {
                        this.receivenovicebenefit(item);
                    }
                } else if (item.benefitStatus === 21) {
                    if (item.redirectUrl) {
                        this.openLink(item.redirectUrl);
                    }
                } else if (item.benefitStatus === 22 || item.benefitStatus === 30) {
                    let mess = item.benefitStatus === 22 ? '优惠券已使用' : '优惠券已过期';
                    this.$toast({
                        message: mess,
                        duration: 2000
                    });
                }
            } else {
                if (
                    item.redirectUrl &&
                    (item.redirectUrl.indexOf('http') > -1 ||
                        item.redirectUrl.indexOf('ppdloanapp') > -1)
                ) {
                    this.openLink(item.redirectUrl);
                } else if (item.redirectUrl) {
                    this.openCurrBenefit(item.redirectUrl);
                }
            }
        },
        allGradesClick() {
            this.homePonitClick('全部权益文字链');
            setTimeout(() => {
                this.openLink(`${window.location.protocol}//invgrowth.ppdai.com/#/allBenefit`);
            }, 200);
        },
        // 领取浮动权益
        async receiveFloatBenefit(item) {
            const { Result, Content, ResultMessage } = await this.$http.receiveFloatBenefit({
                awardKey: item.awardKey
            });
            if (Result === 200) {
                this.$toast({
                    message: '领取成功',
                    duration: 2000
                });
                this.getgradebenefitinfo(false);
                if (Content.redirectUrl) {
                    setTimeout(() => {
                        this.openLink(Content.redirectUrl);
                    }, 2000);
                }
            } else {
                this.$toast({
                    message: ResultMessage,
                    duration: 2000
                });
            }
        },
        // 新手权益领取
        async receivenovicebenefit(item) {
            const { Result, Content, ResultMessage } = await this.$http.receivenovicebenefit({
                awardKey: item.awardKey
            });
            if (Result === 200) {
                this.$toast({
                    message: '领取成功',
                    duration: 2000
                });
                this.getgradebenefitinfo(false);
                if (Content.redirectUrl) {
                    setTimeout(() => {
                        this.openLink(Content.redirectUrl);
                    }, 2000);
                }
            } else {
                this.$toast({
                    message: ResultMessage,
                    duration: 2000
                });
            }
        },
        lowerItemClick() {
            let qpScore = 0;
            this.bubbleScoreList.forEach((item, index) => {
                if (item.bubbleType === 0 && item.afterRewardScore > qpScore) {
                    // 气泡蒙层引导
                    qpScore = item.afterRewardScore;
                    document.scrollingElement.scrollTop = 0;
                    this.taskGuideType = index;
                    this.bubbleInfo = item;
                    this.showTaskGuide = true;
                }
            });
            // if (
            //     this.taskGuideType < 0 &&
            //     this.taskScoreValueList &&
            //     this.taskScoreValueList.length > 0
            // ) {
            //     // 任务蒙层引导
            //     document.scrollingElement.scrollTop = 0;
            //     this.taskGuideType = 10;
            //     this.showTaskGuide = true;
            // }
        },
        getBubbleScoreList(bubbleList, isFirstGrade) {
            this.bubbleScoreList = bubbleList;
            this.getBubbleBarTaskInfo();
            if (isFirstGrade) {
                return;
            }
            console.log('getBubbleScoreList', this.noticeTypeArr);
            if (!this.noticeTypeArr) {
                return;
            }
            // V4版本激活弹窗
            if (this.noticeTypeArr.indexOf('upgradeToV4') > -1) {
                if (!this.showHomecardGuide) {
                    this.showGradeV4Pop = true;
                    this.viewBenefitGuideClose('upgradeToV4');
                    return;
                }
            }
            if (this.noticeTypeArr.indexOf('noviceGuideReceiveBasicScore') > -1) {
                this.newUserGuidData = this.bubbleScoreList;
                this.newUserGuideNum = 1;
                this.showNewUserGuide = true;
                return;
            }

            if (this.noticeTypeArr.indexOf('noviceGuideBenefitCard') > -1) {
                if (
                    this.currentScoreSectionBenefitList &&
                    this.currentScoreSectionBenefitList.length > 0 &&
                    !this.showFirstUpgradePop
                ) {
                    this.newUserGuidData = this.currentScoreSectionBenefitList;
                    this.newUserGuideNum = 2;
                    this.showNewUserGuide = true;
                }
                return;
            }
            if (this.noticeTypeArr.indexOf('noviceGuideTaskBar') > -1) {
                if (
                    this.currentScoreSectionBenefitList &&
                    this.currentScoreSectionBenefitList.length > 0
                ) {
                    this.newUserGuideNum = 3;
                    this.showNewUserGuide = true;
                    return;
                }
            }
        },
        loanButnClick() {
            this.homePonitClick('立即借款');
            this.openLink(this.loanUrl);
        },
        // 跳过新手引导
        skipNoviceGuide() {
            console.log('skipNoviceGuide-00', this.noticeTypeArr);
            this.noticeTypeArr.forEach((item, index) => {
                if (item === 'noviceGuideBenefitCard') {
                    this.noticeTypeArr.splice(index, 1);
                }
                if (item === 'noviceGuideTaskBar') {
                    this.noticeTypeArr.splice(index, 1);
                }
            });
            console.log('skipNoviceGuide-11', this.noticeTypeArr);
            // this.showDialogBox('click_mask_skip');
            this.newUserGuideNum = 0;
            this.showNewUserGuide = false;
        },
        // 气泡引导-气泡点击
        qpGuideClick() {
            this.noticeTypeArr.forEach((item, index) => {
                if (item === 'noviceGuideReceiveBasicScore') {
                    this.noticeTypeArr.splice(index, 1);
                }
            });
            this.showNewUserGuide = false;
            this.$refs.homeCard.guideQPClick();
            this.getTaskScoreValueList();
        },
        // 标记为已读
        markNewGuideRead() {
            this.showNewUserGuide = false;
            this.getUserNotice();
            this.getTaskScoreValueList();
        },
        // 用户引导弹窗接口
        async getUserNotice() {
            const { Result, Content } = await this.$http.getUserNotice();
            if (Result === 200 && Content) {
                this.userGuideNotice = Content;
                this.accountSafeTip = null;
                this.noticeTypeArr = [];
                this.userGuideNotice.forEach(item => {
                    this.noticeTypeArr.push(item.noticeType);
                    if (item.noticeGroup && item.noticeGroup.indexOf('noticeBar') > -1) {
                        this.accountSafeTip = item;
                        this.POINT('h5_element_imp', {
                            page: 'super-成长权益页',
                            tgt_event_id: 'h5_ACT_privilege_tzl',
                            tgt_name: 'h5-ACT-成长权益-通知栏',
                            param: this.isOldCustomer ? this.scoreInfo.totalScore : -1,
                            param1: this.isOldCustomer ? this.scoreInfo.allScore : -1,
                            param2: this.accountSafeTip.noticeText,
                            param3: this.accountSafeTip.redirectUrl,
                            param4: this.switch3d ? '是' : '否'
                        });
                    }
                });
                if (!this.noticeTypeArr.includes('upgradeTo3dNotice') || !this.switch3d) {
                    if (!this.activityId) {
                        this.rankingModel();
                    }
                }
            } else {
                this.userGuideNotice = null;
                this.noticeTypeArr = null;
            }
        },
        // 任务列表弹窗
        async taskList(callMethod) {
            const { Result, Content, ResultMessage } = await this.$http.getTaskListV2({});
            if (Result === 200 && Content) {
                this.showTaskListPopup = true;
                this.taskListContent = Content;
                if (window.PPDWebUI.os.inApp) {
                    appBridge.closePullToRefresh();
                }
                // 签到拉起的弹窗，同时调用签到接口
                if (callMethod === 'callSignIn') {
                    this.$refs.taskListPopupRef.callSignInAfterDataReady();
                }
            } else {
                this.POINT('h5_auth', {
                    auth_tgt: 'super_privilege_errorMsg',
                    auth_tgt_name: 'super-成长权益-报错集合',
                    page: 'super-成长权益页',
                    ret_code: Result,
                    param: ResultMessage,
                    param1: '/growth/home/getTaskListV2',
                    param2: this.$route.query.source,
                    param3: this.switch3d ? '是' : '否'
                });
            }
        },
        async viewBenefitGuideClose(type) {
            const { Result } = await this.$http.setNoticeStatus({
                noticeType: type,
                isRead: true
            });
            if (Result === 200) {
                this.getUserNotice();
            }
        },
        svipClick(item) {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_name: 'h5-ACT-成长权益-付费权益',
                tgt_event_id: 'h5_ACT_privilege_pay',
                param: this.isOldCustomer ? this.scoreInfo.totalScore : 0,
                param1: 0,
                param2: item.status,
                param7: this.switch3d ? '是' : '否'
            });
            if (item.redirectUrl) {
                this.openLink(item.redirectUrl);
            }
        },
        couponPackageClick(item) {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_name: 'h5-ACT-成长权益-付费权益',
                tgt_event_id: 'h5_ACT_privilege_pay',
                param: this.isOldCustomer ? this.scoreInfo.totalScore : 0,
                param1: item.couponPackType,
                param3: item.activityType,
                param4: item.groupId,
                param5: item.userType,
                param6: item.couponPackId,
                param7: this.switch3d ? '是' : '否'
            });
            if (item.redirectUrl) {
                this.openLink(item.redirectUrl);
            }
        },
        homePonitClick(value, expData) {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_name: 'h5_ACT_成长权益',
                tgt_event_id: 'h5_ACT_privilege',
                param: this.isOldCustomer ? this.scoreInfo.totalScore : -1,
                param1: value,
                param2: this.navRightInfo.redirectUrl ? this.navRightInfo.redirectUrl : '',
                param3: this.isOldCustomer ? this.scoreInfo.allScore : -1,
                param4: expData && expData.expiringScore ? '有' : '无',
                param5: this.switch3d ? '是' : '否'
            });
        },
        noticeTypeClick(value) {
            this.goSetting = true;
            this.openLink(value);
        },
        /**
         * 读取通知权限
         */
        readRegisterHanlder() {
            if (PPDWebUI && PPDWebUI.PermissionService) {
                PPDWebUI.PermissionService.readPermission(
                    { permission: 'notification' },
                    result => {
                        if (
                            result &&
                            result.notification &&
                            (result.notification === 'TRUE' || result.notification === true)
                        ) {
                            this.updatePushFlag();
                        }
                        // alert('readPermission' + JSON.stringify(result));
                    },
                    err => {
                        // alert('err' + JSON.stringify(err));
                    }
                );
            } else {
                console.log('PPDWebUI error!');
            }
        },
        // 上报通知开通权限
        async updatePushFlag() {
            if (this.goSetting) {
                const { Result, Content, ResultMessage } = await this.$http.notifyPermission({
                    taskId: 310
                });
                if (Result === 200) {
                    if (ResultMessage) {
                        this.$toast({
                            message: ResultMessage,
                            duration: 2000
                        });
                    }
                }
                this.closeTaskListPopUp();
                this.goSetting = false;
            }
        },
        // 逾期弹窗
        showOverduePopup() {
            this.showOverdueDialog = true;
            this.POINT('h5_element_imp', {
                page: 'super-成长权益页',
                tgt_name: 'h5-ACT-成长权益-逾期提示弹窗',
                tgt_event_id: 'h5_ACT_privilege_yuqibox',
                param: this.scoreInfo.totalScore,
                param1: this.switch3d ? '是' : '否'
            });
        },
        giveupToRepay() {
            this.showOverdueDialog = false;
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_name: 'h5-ACT-成长权益-逾期提示弹窗',
                tgt_event_id: 'h5_ACT_privilege_yuqibox',
                param: this.scoreInfo.totalScore,
                param1: '再看看',
                param2: this.switch3d ? '是' : '否'
            });
        },
        doSomeRepay() {
            this.showOverdueDialog = false;
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_name: 'h5-ACT-成长权益-逾期提示弹窗',
                tgt_event_id: 'h5_ACT_privilege_yuqibox',
                param: this.scoreInfo.totalScore,
                param1: '去还款',
                param2: this.switch3d ? '是' : '否'
            });
            this.openLink('ppdloanapp://repayment/index');
        },
        // 营销任务
        async marketTipClick(itemVlaue) {
            if (
                itemVlaue.taskHandler === 'LLHDongTaskHandler' ||
                itemVlaue.taskHandler === 'JBSLLHDongTaskHandler'
            ) {
                const { Result } = await this.$http.notifyLLHDongTaskDone({
                    taskId: itemVlaue.taskId
                });
                if (Result === 200) {
                    if (itemVlaue.redirectUrl) {
                        this.openLink(itemVlaue.redirectUrl);
                    }
                }
            } else {
                if (itemVlaue.redirectUrl) {
                    this.openLink(itemVlaue.redirectUrl);
                }
            }
        },
        // 活力值任务
        receiveScoreTaskHanlder() {
            this.$refs.homeCard.showBasicScoreGuide();
        },
        // 悬浮窗接口
        async floatingWindowInfoV2() {
            const { Result, Content } = await this.$http.getFloatingWindowInfoV2({});
            if (Result === 200) {
                console.log('content', Content);
                this.floatWindowInfo = Content.lowerRightPopup;
                this.upFloatWindowInfo = Content.upperRightPopup;
                if (this.floatWindowInfo && this.floatWindowInfo.imageUrl) {
                    this.POINT('h5_element_imp', {
                        page: 'super-成长权益页',
                        tgt_name: 'h5-ACT-成长权益-右下悬浮窗',
                        tgt_event_id: 'h5_ACT_privilege_yxxfc',
                        param: this.scoreInfo.totalScore,
                        param1: this.scoreInfo.allScore,
                        param2: this.floatWindowInfo.floatingWindowId,
                        param3: this.floatWindowInfo.imageUrl,
                        param4: this.floatWindowInfo.redirectUrl,
                        param5: this.switch3d ? '是' : '否'
                    });
                }
                if (this.upFloatWindowInfo && this.upFloatWindowInfo.imageUrl) {
                    this.POINT('h5_element_imp', {
                        page: 'super-成长权益页',
                        tgt_name: 'h5-ACT-成长权益-气泡区右上资源位',
                        tgt_event_id: 'h5_ACT_privilege_qpqyszyw',
                        param: this.scoreInfo.totalScore,
                        param1: this.scoreInfo.allScore,
                        param2: this.upFloatWindowInfo.floatingWindowId,
                        param3: this.upFloatWindowInfo.imageUrl,
                        param4: this.upFloatWindowInfo.redirectUrl,
                        param5: this.switch3d ? '是' : '否'
                    });
                }
            }
        },
        floatWindowClick() {
            if (this.floatWindowInfo && this.floatWindowInfo.imageUrl) {
                this.POINT('h5_clk', {
                    page: 'super-成长权益页',
                    tgt_name: 'h5-ACT-成长权益-右下悬浮窗',
                    tgt_event_id: 'h5_ACT_privilege_yxxfc',
                    param: this.scoreInfo.totalScore,
                    param1: this.scoreInfo.allScore,
                    param2: this.floatWindowInfo.floatingWindowId,
                    param3: this.floatWindowInfo.imageUrl,
                    param4: this.floatWindowInfo.redirectUrl,
                    param5: this.switch3d ? '是' : '否'
                });
            }
            if (this.floatWindowInfo.redirectUrl) {
                this.openLink(this.floatWindowInfo.redirectUrl);
            }
        },
        taskGuideClick() {
            this.getUserNotice();
            this.taskGuideType = -1;
            this.showTaskGuide = false;
        }
    }
};
</script>

<style lang="less" scoped>
@asserts: '../../../assets/iconV2.5/';
@assertsV4: '../../../assets/growth4.0/';
.page {
    min-height: 100vh;
    box-sizing: border-box;
    overflow-x: hidden;
    .minTopNav {
        height: 68px;
        padding: 18px 14px 0;
    }
    .maxTopNav {
        height: 88px;
        padding: 38px 14px 0;
    }
    .top-nav {
        position: fixed;
        top: 0px;
        left: 0px;
        width: 375px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.06);
        z-index: 999;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .nav-back-div {
            margin-top: 5px;
            width: 24px;
            height: 24px;
            background-size: 100% 100%;
            background-image: url('@{asserts}/goback-b-icon@2x.png');
        }

        .nav-title {
            width: 90px;
            height: 21px;
            background-image: url('@{asserts}/home-title-blue@2x.png');
            background-size: 100% 100%;
        }

        .nav-title1 {
            margin-left: 106px;
            margin-right: 125px;
        }

        .nav-title2 {
            margin: 0 130px;
        }

        .nav-leftitem {
            display: flex;
            flex-direction: row;
            align-items: center;

            .nav-back {
                width: 24px;
                height: 24px;
                background-size: 100% 100%;
                background-image: url('@{asserts}/goback-b-icon@2x.png');
            }

            .nav-value1 {
                color: #254d5e;
                font-size: 16px;
                // font-family: fzlt_bold;
                font-weight: bold;
            }

            .nav-value2 {
                margin-left: 5px;
                color: #ff8143;
                font-size: 16px;
                // font-family: fzlt_bold;
                font-weight: bold;
            }

            .nav-value3 {
                margin-left: 5px;
                color: #5d7283;
                font-size: 12px;
                // font-family: fzlt;
            }
        }

        .nav-rightitem {
            color: #254d5e;
            font-size: 14px;
            // font-family: fzlt_bold;
            font-weight: bold;
        }
    }
    .svip-div {
        padding: 0 18px;
        margin-top: 30px;

        .vip-title {
            color: #002a3c;
            font-size: 18px;
            // font-family: fzlt_bold;
            font-weight: bold;
        }

        .vip-desc {
            margin-top: 7px;
            font-size: 13px;
            color: #002a3c;
            // font-family: fzlt;
        }

        .vip-card {
            margin-top: 17px;
            width: 339px;
            height: 100px;
            background-image: url('@{asserts}/svip-cardone@2x.png');
            background-size: 100% 100%;
            padding: 15px 20px 0;

            .card-title {
                color: #f6dcb1;
                font-size: 18px;
                // font-family: fzlt_bold;
                font-weight: bold;
            }

            .card-desc {
                color: #efcf99;
                font-size: 12px;
                margin-top: 4px;
            }

            .card-price {
                color: #efcf99;
                font-size: 15px;
                // font-family: fzlt_bold;
                font-weight: bold;
                margin-top: 17px;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;

                .card-butn {
                    margin-left: 11px;
                    width: 70px;
                    height: 24px;
                    background: linear-gradient(
                        90deg,
                        rgba(230, 204, 149, 1) 0%,
                        rgba(226, 191, 120, 1) 100%
                    );
                    border-radius: 15px;
                    color: #906d33;
                    font-size: 12px;
                    text-align: center;
                    line-height: 24px;
                }
            }
        }

        .quan-card {
            margin-top: 10px;
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .quan-item {
                width: 166px;
                height: 91px;
                background-image: url('@{asserts}/svip-cardtwo@2x.png');
                background-size: 100% 100%;
                padding: 15px 0 0 18px;

                .quan-title {
                    color: #684a33;
                    font-size: 15px;
                    // font-family: fzlt_bold;
                    font-weight: bold;
                }

                .quan-desc {
                    margin-top: 6px;
                    color: #b49379;
                    font-size: 11px;
                    // font-family: fzlt;
                }

                .quan-bottom {
                    margin-top: 10px;
                    margin-left: 2px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    .quan-price {
                        color: #684a33;
                        font-size: 11px;
                        font-family: PingFangSC-Regular;
                    }

                    .quan-butn {
                        margin-left: 12px;
                        width: 50px;
                        height: 24px;
                        background: linear-gradient(
                            90deg,
                            rgba(230, 204, 149, 1) 0%,
                            rgba(226, 191, 120, 1) 100%
                        );
                        border-radius: 14px;
                        line-height: 24px;
                        color: #906d33;
                        font-size: 12px;
                        // font-family: fzlt_bold;
                        font-weight: bold;
                        text-align: center;
                    }
                }
            }

            .quan-bg {
                width: 341px;
                height: 91px;
                background-image: url('@{asserts}/svip-qb-bg@2x.png');
                background-size: 100% 100%;
                padding: 15px 18px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                .quan-left {
                    margin-top: 10px;

                    .quan-left-tit {
                        color: #684a33;
                        font-size: 15px;
                        // font-family: fzlt_bold;
                        font-weight: bold;
                    }

                    .quan-left-des {
                        margin-top: 12px;
                        color: #b49379;
                        font-size: 11px;

                        .quan-buy-des {
                            position: relative;
                            left: 8px;
                            color: #684a33;
                            font-size: 11px;
                            // font-family: fzlt;
                        }
                    }
                }

                .quan-right {
                    width: 62px;
                    height: 24px;
                    margin-top: 18px;
                    background: linear-gradient(
                        90deg,
                        rgba(230, 204, 149, 1) 0%,
                        rgba(226, 191, 120, 1) 100%
                    );
                    border-radius: 14px;
                    line-height: 24px;
                    padding-top: 2px;
                    color: #906d33;
                    font-size: 12px;
                    // font-family: fzlt_bold;
                    font-weight: bold;
                    text-align: center;
                }
            }
        }
    }

    .ad-popup {
        position: fixed;
        bottom: 146px;
        right: 10px;
        width: 60px;
        height: 60px;
        z-index: 199;
        background-size: 100% 100%;
    }
    .ad-popup-lottie {
        position: fixed;
        bottom: 170px;
        right: 0px;
        z-index: 199;
    }

    .max-screen {
        bottom: 12px !important;
    }

    .bottom-notice {
        position: fixed;
        bottom: 10px;
        width: 345px;
        height: 36px;
        border-radius: 6px;
        margin: 0 15px;
        background-color: #ffe4b8;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 18px;

        .notice-content {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;

            .notice-close {
                width: 36px;
                height: 36px;
                align-items: center;
                display: flex;

                .notice-x {
                    width: 9px;
                    height: 9px;
                    background-image: url('@{asserts}/noctice-close@2x.png');
                    background-size: 100% 100%;
                }
            }

            .notice-tit {
                width: 100%;
                margin-left: -16px;
                color: #8f5700;
                font-size: 13px;
                // font-family: fzlt_bold;
                font-weight: bold;
            }
        }

        .notice-gif {
            width: 25px;
            height: 25px;
            background-image: url('@{asserts}/notice_tips_arrow.gif');
            background-size: 100% 100%;
        }
    }
}
</style>
